import { replace } from 'svelte-spa-router'
import LocalStorage from '../$services/storage.service'

export default function(body) {

    if(!body.success && body.error && body.error.key === 'tokenExpired') {
        LocalStorage.deleteItem('user')
        LocalStorage.deleteItem('access')
        replace('#/')
    }
}